import { useState } from 'react';
import { useIsRecording } from './useRecorder.js';
import { manualStop } from './recorderService.js';
import { msg } from '../../lib/messages.js';
import './logger.css';

/** ● LOGGER chip on the map while recording; tap → confirm-stop sheet (spec 03). */
export function LoggerChip(): JSX.Element | null {
  const recording = useIsRecording();
  const [confirm, setConfirm] = useState(false);

  if (!recording) return null;

  return (
    <>
      <button
        type="button"
        className="logger-chip"
        onClick={() => setConfirm(true)}
        aria-label={msg.tracks.stopTitle}
      >
        <span className="logger-chip__dot" />
        {msg.tracks.logger}
      </button>

      {confirm && (
        <div className="sheet-backdrop" onClick={() => setConfirm(false)}>
          <div className="sheet" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <div className="sheet__handle" />
            <h2 className="sheet__title">{msg.tracks.stopTitle}</h2>
            <p className="sheet__body">{msg.tracks.stopBody}</p>
            <div className="sheet__actions">
              <button type="button" className="btn btn--ghost" onClick={() => setConfirm(false)}>
                {msg.tracks.keepRecording}
              </button>
              <button
                type="button"
                className="btn btn--accent"
                onClick={() => {
                  manualStop();
                  setConfirm(false);
                }}
              >
                {msg.tracks.stopConfirm}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
